import { render, staticRenderFns } from "./ApplicationsDashboard.vue?vue&type=template&id=881c9104&"
import script from "./ApplicationsDashboard.vue?vue&type=script&lang=js&"
export * from "./ApplicationsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports